import { FunctionComponent } from 'react';
import { CoffeeChatFilterState } from '../../../services/admin/adminCoffeeChatApi';
import {
  DateButton,
  DateButtonIcon,
  DateButtonText,
  DateFilter,
  DateGroup,
  FilterBar,
  FilterGroup,
} from '../common/AdminFilterPrimitives';
import AdminFilterDropdown from '../common/AdminFilterDropdown';
import AdminSearchInput from '../common/AdminSearchInput';

interface CoffeeChatQuestionFilterProps {
  filter: CoffeeChatFilterState;
  onFilterChange: (filter: Partial<CoffeeChatFilterState>) => void;
  onDateModalOpen: () => void;
}

const CoffeeChatQuestionFilter: FunctionComponent<CoffeeChatQuestionFilterProps> = ({
  filter,
  onFilterChange,
  onDateModalOpen,
}) => {
  const visibilityValue =
    filter.visible === true ? 'visible' : filter.visible === false ? 'hidden' : 'all';
  const answeredValue =
    filter.isAnswered === true ? 'answered' : filter.isAnswered === false ? 'unanswered' : 'all';

  const handleVisibilityChange = (value: string) =>
    onFilterChange({ visible: value === 'visible' ? true : value === 'hidden' ? false : null });
  const handleAnsweredChange = (value: string) =>
    onFilterChange({ isAnswered: value === 'answered' ? true : value === 'unanswered' ? false : null });

  return (
    <FilterBar>
      <FilterGroup>
        <DateFilter>
          <DateGroup>
            <DateButton type="button" onClick={onDateModalOpen}>
              <DateButtonText>
                {filter.fromDate && filter.toDate
                  ? `${filter.fromDate} ~ ${filter.toDate}`
                  : filter.fromDate
                    ? `${filter.fromDate} ~`
                    : '등록일'}
              </DateButtonText>
              <DateButtonIcon width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M4.17 5.25L7 8.08L9.83 5.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </DateButtonIcon>
            </DateButton>
          </DateGroup>
        </DateFilter>

        <AdminFilterDropdown
          value={visibilityValue}
          onChange={handleVisibilityChange}
          maxWidth="140px"
          options={[
            { value: 'all', label: '노출 상태' },
            { value: 'visible', label: '노출' },
            { value: 'hidden', label: '숨김' },
          ]}
        />

        <AdminFilterDropdown
          value={answeredValue}
          onChange={handleAnsweredChange}
          maxWidth="140px"
          options={[
            { value: 'all', label: '답변 상태' },
            { value: 'answered', label: '답변 완료' },
            { value: 'unanswered', label: '답변 대기' },
          ]}
        />
      </FilterGroup>

      <AdminSearchInput
        value={filter.searchTerm}
        onChange={(value) => onFilterChange({ searchTerm: value })}
      />
    </FilterBar>
  );
};

export default CoffeeChatQuestionFilter;
